import { ReactNode } from 'react';
import styles from './generator-layout.module.scss';
import { FullscreenHost } from '../fullscreen-host.component';

export interface GeneratorLayoutProps {
    // The form (left column). Use `genStyles.section`, `genStyles.field`,
    // `genStyles.fieldRow`, `genStyles.addBtn` etc. as building blocks.
    form: ReactNode;

    // Preview label + optional small status text (right of label).
    previewLabel: ReactNode;
    previewMeta?: ReactNode;

    // Preview content — typically a <pre> or <textarea readOnly>.
    preview: ReactNode;

    // Actions below the preview (Copy / Download).
    previewActions?: ReactNode;

    // Optional error surface rendered under the preview.
    error?: string | null;

    // Opt-in fullscreen toggle. Off by default because most generators
    // produce short outputs that don't benefit from the chrome being
    // hidden; useful for the editor-shaped ones (markdown-toc, hex-dump).
    expandable?: boolean;
}

// Form-on-left, sticky-preview-on-right layout for generator pages
// (robots-txt, sitemap, meta-tag, json-ld, htaccess, twitter-card, etc.)
// Keeps the live preview in view as the user scrolls through a tall form.
export function GeneratorLayout(props: GeneratorLayoutProps) {
    const body = (
        <div className={styles.grid}>
            <div className={styles.form}>{props.form}</div>

            <div className={styles.previewCol}>
                <div className={styles.previewHeader}>
                    <span className={styles.previewLabel}>{props.previewLabel}</span>
                    {props.previewMeta && <span className={styles.previewMeta}>{props.previewMeta}</span>}
                </div>
                {props.preview}
                {props.error && (
                    <div style={{ marginTop: '0.75rem', padding: '0.6rem 0.85rem', background: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', borderRadius: 6, fontSize: '0.85rem' }} role="alert">
                        {props.error}
                    </div>
                )}
                {props.previewActions && (
                    <div className={styles.previewActions}>{props.previewActions}</div>
                )}
            </div>
        </div>
    );
    return props.expandable ? <FullscreenHost>{body}</FullscreenHost> : body;
}

export const genStyles = styles;
